import { useGetFisheryQuery } from '../../../../fishery_profile/fisherySlice';
import {
  useGetBrandsQuery,
  useUpdateBrandEngagementMutation,
} from '../../../../brands/brandsSlice';
import React, { useMemo, useState } from 'react';
import { shuffleArray } from '../../../../../utils/arrayUtils';
import BrandDetailsModal from '../../../../brands/components/brandDetailsModal';
import '../../../../brands/assets/css/brands.css';

function BrandCard({ brand }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateEngagement] = useUpdateBrandEngagementMutation();
  return (
    <>
      <BrandDetailsModal
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        brandData={brand}
      />
      <div
        key={brand.id}
        className='brand-card cp'
        onClick={() => {
          setIsModalOpen(true);
          updateEngagement({ brand_id: brand?.id, source: 'application' });
        }}
      >
        <div className='fs-16 gBold sb-blue-600 brand--mobile'>
          {brand.brand_name}
        </div>
        <div className='fs-12 gSemiBold grey-400 brand--mobile mg-bottom-5'>
          {brand.subheading}
        </div>
        <div className='brand-logo border-3 br15 sb-blue-border-100'>
          <img src={brand?.primary_image ?? brand.logo_image} alt={brand.brand_name} />
        </div>
        <div className='fs-17 gBold sb-blue-600 brand--desktop'>
          {brand.brand_name}
        </div>
        <div className='fs-12 gSemiBold grey-400 brand--desktop'>
          {brand.subheading}
        </div>
      </div>
    </>
  );
}

export default function MarketingBrandsCard({ fisheryPublicId }) {
  const {
    data: fisheryData,
    isFetching: loadingFisheryData,
    isError: fisheryDataError,
  } = useGetFisheryQuery(fisheryPublicId);

  const { data, isLoading, isError } = useGetBrandsQuery({ tiers: ['tier1'] });
  const shuffledBrands = useMemo(
    () => (data?.length ? shuffleArray([...data]) : data),
    [data]
  );

  if (
    !isError &&
    !fisheryDataError &&
    !fisheryData?.allowed_marketing_tiers?.includes?.('tier1')
  ) {
    return null;
  }

  if (!isLoading && !isError && !data?.length) {
    return null;
  }

  return (
    <div
      id={'brands'}
      className={'br20 pd-top-20 pd-bottom-10 txt-center mg-bottom-5'}
    >
      <h2 className='gBold fs-21 grey-900 mg-bottom-0 mg-top-5'>
        🪝 Have you got everything you need?
      </h2>
      <p className='gMedium fs-17 grey-400 mg-bottom-10'>
        Consider using our partner brands
      </p>
      <div className={'br20 pd-20 pd-left-30 pd-right-30 bg-white'}>
        {isLoading || loadingFisheryData ? (
          <div className='loading'>Loading brands...</div>
        ) : isError || fisheryDataError ? (
          <div className='error'>Error loading brands</div>
        ) : (
          <>
            <div className='brands-grid brands-grid--narrow'>
              {shuffledBrands.map((brand) => (
                <BrandCard key={brand.id} brand={brand} />
              ))}
            </div>
            <p className='gMedium fs-14 grey-400 mg-bottom-10 mg-top-30 brand--desktop lh-1.45'>
              <strong className='gBold sb-blue-500'>
                ➡️ Want to check these out later?
              </strong>{' '}
              These offers are claimable on the swimbooker website & mobile app!
            </p>
            <p className='fs-16 gBold sb-blue-500 mg-top-20 mg-bottom-8 brand--mobile'>
              ➡️ Want to check these out later?
            </p>
            <p className='gMedium fs-15 grey-400 mg-bottom-10 brand--mobile lh-1.45'>
              These offers are claimable on the swimbooker website & mobile app!
            </p>
          </>
        )}
      </div>
    </div>
  );
}
